import React, { Component } from 'react'
import PropTypes from 'prop-types'
import VisibilitySensor from 'react-visibility-sensor'


class ShowOnVisible extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isVisible: false,
    }
    this.onVisibilityChange = this.onVisibilityChange.bind(this)
  }

  componentDidUpdate(prevProps) {
    if(
      // Sometimes it does not trigger onChange when scroll jump to the collapsible
      // ios issue.
      prevProps.makeItVisible !== this.props.makeItVisible &&
      !this.state.isVisible
    ) {
      this.onVisibilityChange(true)
    }
  }

  onVisibilityChange(isVisible) {
    if(!this.state.isVisible && isVisible) {
      this.setState({
        isVisible,
      })
      this.props.onVisibleHandler()
    }
  }

  render() {
    const offset = this.props.offset || { bottom: -300 }
    // console.log(this.state.isVisible)
    return (
      <VisibilitySensor onChange={this.onVisibilityChange} offset={offset} scrollCheck >
        <div style={{ width: '100%', minHeight: '20px' }}>
          {this.state.isVisible ? this.props.children : ''}
        </div>
      </VisibilitySensor>
    )
  }
}

ShowOnVisible.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  offset: PropTypes.shape({}),
  onVisibleHandler: PropTypes.func,
  makeItVisible: PropTypes.bool,
}
ShowOnVisible.defaultProps = {
  onVisibleHandler: () => {},
}

export default ShowOnVisible
